import { render, staticRenderFns } from "./PaymentRequestTable.vue?vue&type=template&id=88d793a2&scoped=true&"
import script from "./PaymentRequestTable.vue?vue&type=script&lang=js&"
export * from "./PaymentRequestTable.vue?vue&type=script&lang=js&"
import style0 from "./PaymentRequestTable.vue?vue&type=style&index=0&id=88d793a2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88d793a2",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDataTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VDataTable})
